import * as classnames from 'classnames';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Body1 } from '@estee/elc-typography';
import {
    TextBackgroundColorTheme,
    ErrorTextTheme,
    StyledLabelMovedUpTheme
} from '../theme/default-theme';

export interface IMarkAsError {
    markAsError?: boolean;
}

const StyledLabelText = styled(Body1)`
    line-height: 26px;
`;

const RelativePositionedTextWrapper = styled('span')<
    IMarkAsError & React.HtmlHTMLAttributes<HTMLSpanElement>
>`
    position: relative;
    ${TextBackgroundColorTheme} ${({ markAsError }) =>
        markAsError &&
        css`
            ${ErrorTextTheme};
        `};
`;

const Label: React.FunctionComponent<IInputLabelProps> = props => {
    const labelClassName = classnames(
        'elc-floating-label-string',
        'js-floating-label-string',
        props.className
    );

    return (
        <StyledLabelText htmlFor={props.inputId} className={labelClassName}>
            <RelativePositionedTextWrapper
                className={'js-relative-positioned-text-wrapper'}
                markAsError={props.markAsError}
            >
                {props.children}
            </RelativePositionedTextWrapper>
        </StyledLabelText>
    );
};

const moveLabelUpCss = ({
    moveLabelUp,
    readOnly
}: {
    moveLabelUp: boolean;
    readOnly: boolean;
}): string => {
    if (moveLabelUp) {
        return `
                ${StyledLabelMovedUpTheme}
                text-transform: capitalize;
                background: transparent;
                opacity: 1;
                top: 0;
                transform: translateY(-50%);
            `;
    } else if (!readOnly) {
        return 'cursor: text;';
    } else {
        return '';
    }
};

const StyledLabel = styled(Label)`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: absolute;
    margin: 0;
    top: ${props => (props.elementType === 'textarea' ? '15px' : '50%')};
    transform: translateY(-50%);
    left: 15px;
    max-width: calc(100% - 30px);
    transition-property: top font-size;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;
    opacity: 0.7;
    padding: 0 6px;
    user-select: none;
    animation-duration: 0.2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    pointer-events: none;
    ${moveLabelUpCss};

    [dir='rtl'] & {
        right: 15px;
        left: auto;
    }

    &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: calc(50% + 3px);
        box-sizing: content-box;
        z-index: 0;
        ${TextBackgroundColorTheme};
    }
`;

export interface IInputLabelProps extends React.HTMLProps<{}> {
    className?: string;
    elementType?: string;
    inputId: string;
    moveLabelUp: boolean;
    readOnly: boolean;
    markAsError?: boolean;
}

export { StyledLabel };
